/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MarkupOutput,
    MarkupOutputFromJSON,
    MarkupOutputFromJSONTyped,
    MarkupOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupOutputIEnumerableBusinessDataResponse
 */
export interface MarkupOutputIEnumerableBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof MarkupOutputIEnumerableBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<MarkupOutput>}
     * @memberof MarkupOutputIEnumerableBusinessDataResponse
     */
    businessData?: Array<MarkupOutput> | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupOutputIEnumerableBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkupOutputIEnumerableBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkupOutputIEnumerableBusinessDataResponse
     */
    totalRecords?: number;
}

export function MarkupOutputIEnumerableBusinessDataResponseFromJSON(json: any): MarkupOutputIEnumerableBusinessDataResponse {
    return MarkupOutputIEnumerableBusinessDataResponseFromJSONTyped(json, false);
}

export function MarkupOutputIEnumerableBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupOutputIEnumerableBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(MarkupOutputFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function MarkupOutputIEnumerableBusinessDataResponseToJSON(value?: MarkupOutputIEnumerableBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(MarkupOutputToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


